import { Icon, SearchInput, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Text, View, Pressable } from 'native-base';
import React from 'react';

import { HeaderSection } from './components/HeaderSection';
import { RestrictedCustomersList } from './components/RestrictedCustomersList';
import { SubHeader } from './components/SubHeader';
import { searchPlaceholder } from './constants';
import { BlockListTypes } from './types';

export const ContainerMobile: React.FC<BlockListTypes.Props> = ({
  isMobile,
  onClearSearchTerm,
  onSetSearchTerm,
  onLoadMore,
  blockList,
  blockListLoading,
  blockListRetryLoading,
  filtered,
  sendRetryUnlockCustomer,
  onRefresh,
  currentOptoutId,
  toggleOpen,
  isOpenWarning,
}) => {
  return (
    <View
      px={Spacing['inline.xxxs']}
      py={Spacing['inline.xxxs']}
      width="100%"
      minW="container"
      flex={1}>
      <HeaderSection isMobile={isMobile} />
      <SubHeader onRefresh={onRefresh} isMobile={isMobile} />

      <Box flex={1} bg="transparent">
        <VStack flex={1}>
          <Box pb={Spacing['inline.nano']}>
            <SearchInput
              isMobile={true}
              isLoading={blockListLoading}
              onClear={onClearSearchTerm}
              onSearch={onSetSearchTerm}
              placeholder={searchPlaceholder}
            />
          </Box>

          {isOpenWarning && (
            <HStack
              testID="warning-container"
              backgroundColor="rgba(254, 225, 178, 0.4)"
              borderRadius="8px"
              mt={Spacing['inline.nano']}
              mb={Spacing['inline.xxxs']}
              width="100%"
              alignItems="center"
              justifyContent="space-between"
              py={Spacing['inline.nano']}
              px={Spacing['inline.xxxs']}>
              <HStack paddingRight={Spacing['inline.quarck']} flex={1} alignItems="center">
                <Text color="neutral.black" fontSize={Typography['fontsize.md']} variant="regular">
                  <Text fontWeight={Typography['fontweight.semibold']}>Atenção:</Text> É necessário
                  que você pesquise pelos clientes para visualizar os bloqueados. Após solicitar o
                  desbloqueio, você não poderá reenviar a solicitação no período de 3 horas.
                </Text>
              </HStack>

              <Pressable alignSelf="flex-start" onPress={toggleOpen}>
                <Icon
                  testId="warning-icon"
                  name="Close"
                  size="xxxs"
                  color={Color['neutral.dark']}
                />
              </Pressable>
            </HStack>
          )}

          <RestrictedCustomersList
            currentOptoutId={currentOptoutId}
            blockListRetryLoading={blockListRetryLoading}
            sendRetryUnlockCustomer={sendRetryUnlockCustomer}
            isMobile
            blockList={blockList}
            blockListLoading={blockListLoading}
            onLoadMore={onLoadMore}
            filtered={filtered}
          />
        </VStack>
      </Box>
    </View>
  );
};
